// api/services/creatives.ts
import { fetchCustomerResource, handleRequest } from '@/api';
import type { Creative } from '@/types';

interface CustomerRef {
    id: number;
}

interface CreativePayload {
    description: string;
    customer_id: number;
    creative_format?: string | null;
    creative_type?: string | null;
}

interface CreativeUpdatePayload extends CreativePayload {
    id: number;
}

interface CreativeOperationResponse {
    message: string;
    creative_id: number;
}

export const getCreativesForCustomer = (customer: CustomerRef, signal?: AbortSignal): Promise<Creative[]> =>
    fetchCustomerResource<Creative[]>('creatives', customer.id, signal);

export const saveNewCreative = (creative: CreativePayload): Promise<CreativeOperationResponse> =>
    handleRequest<CreativeOperationResponse>('post', `/creatives/`, creative, 'Creative saved successfully!');

export const updateCreative = (payload: CreativeUpdatePayload): Promise<CreativeOperationResponse> =>
    handleRequest<CreativeOperationResponse>('put', `/creatives/${payload.id}`, payload, 'Creative updated.');

export const checkCreativeArchive = (creativeId: number) =>
    handleRequest<{ can_archive: boolean; reason?: string; details?: Record<string, unknown> }>(
        'get',
        `/creatives/${creativeId}/archive-check`
    );

export const archiveCreative = (creativeId: number) =>
    handleRequest<CreativeOperationResponse>('post', `/creatives/${creativeId}/archive`, {}, 'Creative archived.');
